import { Component, Input, OnInit, Output, EventEmitter, ViewEncapsulation, ViewChild } from '@angular/core';
import { MessageService, SelectItem } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { RulesService } from 'app/services/audit/rules.service';
import { Acm } from 'app/models/loyalty-acm.model';
import { AuditRuleObject, AuditRulesConditionType, AuditRulesType } from 'app/views/audit/models/audit-event.model';
import { Campaign3KontableComponent } from 'app/views/campaign-3/components/campaign-3-kontable/campaign-3-kontable.component';
import { ActivatedRoute } from '@angular/router';
import { AcmTypehasReason } from 'app/models/loyalty-acm-type.model';
import { RuleConditionsService } from 'app/services/audit/ruleconditions.service';
@Component({
  selector: 'app-audit-condition',
  templateUrl: './audit-condition.component.html',
  styleUrls: ['./audit-condition.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AuditConditionComponent implements OnInit {

  @Input() ui_mode: string = this.rulesService.ui_modes.CREATE;
  @Input() language: string = "it";
  @Input() dateFormat: string = "dd/MM/yyyy";
  @Input() readOnly: boolean = false;
  @Input() formSchema: any;
  @Input() auditRuleObject: AuditRuleObject;
  @Input() listReasonsFiltered: SelectItem[] = [];
  @Input() listReasonsFull: Array<AcmTypehasReason> = [];
  @Input() clusterOption: SelectItem[];
  @Input() clusterOptionActive: SelectItem[];
  @Input() touchpointOption: SelectItem[];
  @Input() sourceSystemOption: SelectItem[];
  @Input() acmList: SelectItem[];
  @Input() acmListFull: Array<Acm> ;
  @Input() listReasons: SelectItem[];
  @ViewChild('conditionListTable') conditionListTable: Campaign3KontableComponent;
  @Input() ruleId: number;
  @Input() isChallenge: boolean = false;
  @Output() conditionObjectChanged: EventEmitter<AuditRuleObject> = new EventEmitter<AuditRuleObject>();

  conditionsType: Array<AuditRulesConditionType>;
  conditionsTypeCombo: SelectItem[];
  operatorBooleanCondition: SelectItem[];
  selectedOperatorBooleanCondition: string;
  //elementi che regolano il p-selectButton
  showAddNewCondition: boolean;
  paginationType = Campaign3KontableComponent.ServerPagination;
  customFilter = Campaign3KontableComponent.CustomFilter;
  selectCustomFilter = Campaign3KontableComponent.CustomFilter;
  selectFilter = Campaign3KontableComponent.SelectFilter;
  disabled = {
    tutti: false,
    noloyalty: false
  }

  show = {
    warningCondition: false,
    form: false,
    table: false
  }

  valid: boolean = true;
  auditRuleConditionEditId: number;
  //evento che volevo chiamare se la validazione fosse andata a buon termine
  @Output() validationResult: EventEmitter<boolean> = new EventEmitter<boolean>();
  ruleConditionCondtionId: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    public rulesService: RulesService,
    public ruleConditionsService: RuleConditionsService,
    private srvMessage: MessageService,
    private translate: TranslateService
  ) {

  }
  ngOnInit(): void {
    this.ruleConditionsService.ruleId = this.ruleId;
    this.show.table = true;
    if(!this.ui_mode){
      this.ruleId = this.activatedRoute.snapshot.params['idRule'];
      if(!this.ruleId){
        this.ui_mode = this.rulesService.ui_modes.CREATE
      }
    }
    this.loadConditionType();
    this.getOperatorBooleanCondition();

     if (this.ui_mode == this.rulesService.ui_modes.EDIT) {
      this.selectedOperatorBooleanCondition = this.auditRuleObject.rule.conditionBooleanOperator;
      this.loadConditionsRule();
    }

  }
  getOperatorBooleanCondition() {
    this.operatorBooleanCondition = [{label: '', value: null}];
    this.operatorBooleanCondition.push({label: this.translate.instant('audit.booleanOperatorAnd'), value: 'AND'})
    this.operatorBooleanCondition.push({label: this.translate.instant('audit.booleanOperatorOr'), value: 'OR'});//value = audit.audit_rule_condition.flg_boolean_condition 0/1
  }

  loadConditionType() {
    this.rulesService.getConditionTypeList().subscribe(res => {
      this.conditionsTypeCombo = [];
      this.conditionsType = [];
      if (res) {
        res.forEach(typeRule => {
          this.conditionsTypeCombo.push({label: `${typeRule.description}` , value: typeRule.id })
          this.conditionsType.push(typeRule);
        });
      }
    });
  }

  loadConditionsRule() {
    // this.table.filter.search.push({key: 'rule_id', value: this.auditRuleObject.rule.id, filterType: 'equals'});
    this.conditionListTable.refresh();
  }
  performValidationCondition(): boolean {
    this.valid = true;
    return this.valid;
  }

  openAddNewCondition() {
    this.showAddNewCondition = true;
  }

  closeAddNewCondition(auditRuleObject: AuditRuleObject) {
    //caso in cui sto salvando la regola direttamente dal dettaglio, cioè facendo il salvataggio come ultimo step
    if(auditRuleObject && auditRuleObject.rule && auditRuleObject.rule.id){
      this.auditRuleObject = auditRuleObject;
      this.ruleConditionsService.ruleId = auditRuleObject.rule.id;
      this.refreshAfterEdit() ;
    }
    this.showAddNewCondition = false;
    this.auditRuleConditionEditId = null;
  }

  reloadRuleList(){
    console.log("reloadRuleList");
  }

  refreshAfterEdit() {
    var self = this;
    setTimeout(function () {
      self.conditionListTable.refresh();
      self.showAddNewCondition = false;
    }, 200);
  }

openEditCondition(auditRuleConditionEditId: any) {
  this.auditRuleConditionEditId = auditRuleConditionEditId;
  this.showAddNewCondition = true;
}

onRemoveRuleCondition(rowId: any) {
  this.ruleConditionsService.deleteAuditRuleCondition(rowId).subscribe(res => {
    this.auditRuleObject.auditRuleCondition = this.auditRuleObject.auditRuleCondition.filter(f => f.id !== rowId);
    if (res) {
      this.srvMessage.add({
        severity: 'success',
        summary: this.translate.instant('common.success'), // Usa la traduzione per "Success"
        detail: this.translate.instant('audit.operation_successful')
      });
    this.conditionListTable.refresh();
    }else{
      this.srvMessage.add({
        severity: 'error',
        summary: this.translate.instant('common.error'),
        detail: this.translate.instant('audit.genericConditionError')
      });
    }
  });
}

getConditionTypeDescription(row: any) {
  return row.audit_rules_condition_type_id.description;
}

getItemConditionDescription(row: any){
  let appTypeConditionFull: AuditRulesConditionType;
  if(row.audit_rules_condition_type_id && row.audit_rules_condition_type_id.id){
    appTypeConditionFull =  this.conditionsType.find(f => f.id === (row.audit_rules_condition_type_id.id));
  }else{
    appTypeConditionFull =  this.conditionsType.find(f => f.id === (row.audit_rules_condition_type_id as any));
  }
  if (appTypeConditionFull.code === "acm") {
    return (this.acmList.find(f => f.value === row.condition_entity_id)).label; //ruleTable.acm_id;

  }

  if (appTypeConditionFull.code === "cluster") {
    return (this.clusterOption.find(f => f.value == row.condition_entity_id)).label;
  }

  if (appTypeConditionFull.code === "touchpoint") {
    return (this.touchpointOption.find(f => f.value == row.condition_entity_id)).label;
  }

  if (appTypeConditionFull.code === "source_system") {
    return (this.sourceSystemOption.find(f => f.value == row.condition_entity_id)).label;
  }

  if (appTypeConditionFull.code === "movement") {
    return (this.acmList.find(f => f.value === row.condition_entity_id)).label +" ==>>  "
      + (this.listReasonsFull.find(f => f.reason_id === row.reason_condition_id)).reasonDescription;

  }
  return row.condition_entity_id;
}
onConditionObjectChanged(auditRuleObject: AuditRuleObject) {
  this.conditionObjectChanged.emit(auditRuleObject);
}

}



// WEBPACK FOOTER //
// ./src/app/views/audit/rules/add-rule/audit-condition/audit-condition.component.ts